

﻿


// This file was automatically generated by the PetaPoco T4 Template
// Do not make changes directly to this file - edit the template instead
// 
// The following connection settings were used to generate this file
// 
//     Connection String Name: ``
//     Provider:               `System.Data.SqlClient`
//     Connection String:      `server=localhost;Integrated Security=True;database=TooBig4Car;`
//     Schema:                 `dbo`
//     Include Views:          `False`

					
				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { ContentAndStatus } from '../../Models/OtherClasses';

@Injectable()
export class ShipmentBOLService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('ShipmentBOL');
	}
	
	changeCustomer(searchObj: TooBig4Car.Logic.ShipmentBOLCustomerChangeVM): Observable<TooBig4Car.Logic.ShipmentBOL> {
		return this.myBaseService.post(searchObj, this.url + '/ChangeCustomer', true);
	}
	save(tempItem: TooBig4Car.Logic.ShipmentBOL) : Observable<ContentAndStatus<TooBig4Car.Logic.ShipmentBOL>> {
		return this.myBaseService.postWithStatusCode(tempItem, this.url, true);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.ShipmentBOL> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.ShipmentBOL>{
		return this.myBaseService.get(id, this.url);
	}
	search(searchObj: TooBig4Car.Logic.SearchVM) : Observable<TooBig4Car.Logic.ShipmentBOL[]>{
		return this.myBaseService.post(searchObj, this.url + '/Search', false);
	}

	getSplit(id: System.Guid): Observable<TooBig4Car.Logic.SplitShipmentVM> {
		return this.myBaseService.get(id, this.url +'/Split');
	}
	saveSplit(tempItem: TooBig4Car.Logic.SplitShipmentVM): Observable<ContentAndStatus<TooBig4Car.Logic.SplitShipmentVM>> {
		return this.myBaseService.postWithStatusCode(tempItem, this.url + '/Split', true);
	}
}
				
